import React from 'react';
import { Spin } from 'antd';
import { CoreExtensionSlotParams } from '../Common/type';

const LazyUserProfile = React.lazy(() => import('./UserProfile'));

export const AsyncUserProfile: React.FC<CoreExtensionSlotParams<any>> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazyUserProfile {...props} />
	</React.Suspense>
);

const LazyUserProfileActions = React.lazy(() => import('./UserProfileActions'));

export const AsyncUserProfileActions: React.FC<CoreExtensionSlotParams<any>> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazyUserProfileActions {...props} />
	</React.Suspense>
);

const LazyMFAEnabledUserPreferences = React.lazy(() => import('./UserPreferences'));
export const AsyncMFAEnabledUserPreferences: React.FC<
	CoreExtensionSlotParams<any>
> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazyMFAEnabledUserPreferences {...props} />
	</React.Suspense>
);

const LazyPasswordRequirements = React.lazy(() => import('./PasswordRequirements'));
export const AsyncPasswordRequirements: React.FC<
	CoreExtensionSlotParams<any>
> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazyPasswordRequirements {...props} />
	</React.Suspense>
);

const LazySocialSignIn = React.lazy(() => import('./SocialSignIn'));
export const AsyncSocialSignIn: React.FC<CoreExtensionSlotParams<any>> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazySocialSignIn {...props} />
	</React.Suspense>
);

const LazyAccountMFASettings = React.lazy(() => import('./AccountMFASettings'));
export const AsyncAccountMFASettings: React.FC<CoreExtensionSlotParams<any>> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazyAccountMFASettings {...props} />
	</React.Suspense>
);

const LazySingleSignOn = React.lazy(() => import('./SingleSignOn'));
export const AsyncSingleSignOn: React.FC<CoreExtensionSlotParams<any>> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazySingleSignOn {...props} />
	</React.Suspense>
);

const LazySupportSecurityQuestion = React.lazy(() => import('./SupportSecurityQuestion'));
export const AsyncSupportSecurityQuestion: React.FC<
	CoreExtensionSlotParams<any>
> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazySupportSecurityQuestion {...props} />
	</React.Suspense>
);

const LazyOTPAdminSettings = React.lazy(() => import('./OTPAdminSettings'));
export const AsyncOTPAdminSettings: React.FC<CoreExtensionSlotParams<any>> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazyOTPAdminSettings {...props} />
	</React.Suspense>
);
